<template>
    <svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <path
            d="M48 87C69.5391 87 87 69.5391 87 48C87 26.4609 69.5391 9 48 9C26.4609 9 9 26.4609 9 48C9 69.5391 26.4609 87 48 87Z"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
        />
        <!-- @vue-ignore -->
        <path
            d="M48.4372 43.9167C53.5688 43.9167 57.7289 39.7566 57.7289 34.625C57.7289 29.4934 53.5688 25.3333 48.4372 25.3333C43.3056 25.3333 39.1455 29.4934 39.1455 34.625C39.1455 39.7566 43.3056 43.9167 48.4372 43.9167Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
            fill="none"
        />
        <!-- @vue-ignore -->
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.1455 66.9584C32.9364 66.9584 31.1455 65.1675 31.1455 62.9584V59.7619C31.1455 55.6593 34.4714 52.3334 38.5741 52.3334H56.7586C60.8613 52.3334 64.1872 55.6593 64.1872 59.7619V62.9584C64.1872 65.1675 62.3963 66.9584 60.1872 66.9584H35.1455Z"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
        />
    </svg>
</template>
